import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from 'Components';
import './CheckItem.css';

const CheckItem = ({
  title,
  checked,
  className,
  onClick,
  dir,
  ...rest
}) => (
  <div className={`check-item ${className}`}>
    { dir === 'left' &&
      <CheckBox {...rest} checked={checked} onClick={onClick} className="check-box--left" />
    }
    { title && <span className="check-item__title">{title}</span> }
    { dir === 'right' &&
      <CheckBox {...rest} checked={checked} onClick={onClick} className="check-box--right" />
    }

  </div>
);

CheckItem.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  dir: PropTypes.string,
};

CheckItem.defaultProps = {
  checked: false,
  className: '',
  dir: 'left',
};

export default CheckItem;



// WEBPACK FOOTER //
// ./src/components/CheckItem/CheckItem.jsx